import c from "../../../utils/constants";

class NavbarController {

  activeLocation;

  constructor($scope, AuthService, AppContextService, FilterService, EventsService, NavigationService) {
    "ngInject"
    this.authService = AuthService;
    this.appContextService = AppContextService;
    this.filterService = FilterService;
    this.eventsService = EventsService;
    this.navigationService = NavigationService;

    $scope.$watch("vm.activeLocation", this.onLocationChange.bind(this), true);
  }

  $onInit() {
    this.appContext = this.appContextService.getAppContext();
    this.activeLocation = this.appContextService.getActiveLocation();

		this.eventsService.listen(c.events.AUTHORIZATION_SUCCESS, () => {
			this.appContext = this.appContextService.getAppContext();
			console.log("AUTHORIZATION_SUCCESS Event listener called", this.appContext)
		})
  }

  onLocationChange(value) {
    this.appContextService.setActiveLocation(value);
  }

  logout() {
    this.authService.logout();
    this.appContextService.clearAppContext();
  }

  applyGlobalFilter(filter) {

    for(var i = 0; i < this.globalFilterOptions.length; i++) {
      if(this.globalFilterOptions[i] == filter) this.globalFilterOptions[i].isActive = true;
      else this.globalFilterOptions[i].isActive = false;
    }

    this.eventsService.broadcast(c.events.GLOBAL_FILTER_APPLIED, filter);
  }

}

export default NavbarController;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/Components/navbar/navbar.controller.js
 **/